var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.46377 8.0348C6.45292 8.0348 8.0855 6.4022 8.0855 4.37083C8.0855 2.33946 6.45292 0.749084 4.46377 0.749084C2.47463 0.749084 0.799805 2.38638 0.799805 4.37083C0.799805 6.35529 2.4324 8.0348 4.46377 8.0348ZM7.55525 10.6385H1.41895V30.4737H7.55525V10.6385ZM21.1091 15.6302C18.6367 15.6302 17.356 17.2675 17.356 20.0495H17.3607V30.4737H11.4871V10.6386H17.3607V13.2892C17.3607 13.2892 19.1246 10.0193 23.3187 10.0193C27.5128 10.0193 30.5153 12.5855 30.5153 17.929V30.4737H24.4212V20.0495C24.4212 17.2206 23.361 15.6302 21.1091 15.6302Z","fill":"white"}));
}

Linkedin.defaultProps = {"width":"31","height":"31","viewBox":"0 0 31 31","fill":"none"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
